<section id="codingEducation" class="col d-lg-flex d-md-flex coding-reimbursement">
    <section id="leftSection" class="col-md-8 col-lg-8 col-xl-8 left-section">
        <div class="row row-20" id="product-overview-carousel">
            <div class="col-md-12 product-carousel-wrapper reimbursement-wrapper">
                <p class="carousel-title reservation-details">Featured resources</p>
                <hr class="hr-line-12 lineM">
                <div class="slick-carousel slick-initialized">
                    <div aria-live="polite" class="slick-list draggable">
                        <div class="slick-track"
                            style="opacity: 1; width: 5000px; transform: translate3d(0px, 0px, 0px);" role="listbox">
                            <div class="w-5 slick-item rem-slick featured-resource-section slick-slide slick-current slick-active"
                                tabindex="-1" role="option" aria-describedby="slick-slide00" data-slick-index="0"
                                aria-hidden="false">
                                <div class="mini-card">
                                    <div class="minicardGroup-A">
                                        <div class="featured-resources" *ngIf="cmsResponse">
                                            <img src="{{baseUrl}}{{cmsResponse?.featuredProductImage?.url}}"
                                                class="carouselImg">
                                            <h3>{{cmsResponse?.header}}</h3>
                                            <p class="three-p">{{cmsResponse?.text}}</p>
                                            <button class="btn-primary mb-28"
                                                (click)="openLinkInNewWindow(cmsResponse?.buttonActinLink?.url)"
                                                tabindex="0">{{cmsResponse?.linkButtonName}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row-20 border-bottom-4 paginationBox align-items-center">
            <div id="filter-applied">
                <div class="col-lg-6 col-md-6 col-sm-7 filterApply-showing reimbursement-filter">
                    <span *ngIf="(currPage+1) < totalPages">Showing {{(docList.length) * (currPage+1)}} of
                        {{totalDocuments}} documents</span>
                    <span *ngIf="(currPage+1) == totalPages">Showing {{totalDocuments}} of {{totalDocuments}}
                        documents</span>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-5 top-pagination hidden-xs d-lg-flex d-md-flex justify-content-end">
                    <div id="pageSelectedNumber">Page {{currPage + 1}} of {{totalPages}}</div>
                    <div class="pagination ml-4">
                        <button class="pagination-btns mr-1" [disabled]="currPage == 0" (click)="paginationPrev()">
                            <span class="chevronIconWhite prev">
                                < </span>
                        </button>
                        <button class="pagination-btns" [disabled]="currPage == totalPages-1"
                            (click)="paginationNext()">
                            <span class="chevronIconWhite next"> > </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col docs-wrapper">
                <h3 class="docs">All documents</h3>
                <p class="docs-desc">Here's everything you need to navigate the reimbursement process, including current
                    product codes, training materials, and more.</p>
            </div>
        </div>
        <div class="row d-block browse-category border-bottom-4">
            <div class="col pl-12 pr-12">
                <p class="browse-category-header">Browse By Category</p>
            </div>
            <div class="col-lg-6 pl-12 pr-12">
                <ng-select name="docCategoryFilter" [items]="docCategoryFilterList" [searchable]="false"
                    [clearable]="false" bindLabel="name" bindValue="code" class="dropdown-credit float-left mb-12"
                    [(ngModel)]="filterSelected" (ngModelChange)="getDocumentList()">
                </ng-select>
            </div>
        </div>
        <div class="row d-block">
            <div class="col d-flex docDetailBorder">
                <div class="col-3">
                    <label class="radioTitle d-flex">
                        <input type="radio" [checked]="allDocSelected" (click)="allSelected()" class="d-none">
                        <div class="checkmark" (mouseenter)="hoverAllItem(true, allDocSelected)"
                            (mouseleave)="hoverAllItem(false, allDocSelected)">
                            <div class="greendot" *ngIf="allDocSelected && !hovered"></div>
                            <div class="graydot" *ngIf="!allDocSelected && hovered"></div>
                        </div>
                        <span class="ml-2 align-middle">All</span>
                    </label>
                </div>
                <div class="col-9">
                    <label class="radioTitle">
                        <span class="align-middle">Document</span>
                    </label>
                </div>
            </div>
            <div class="col d-flex docDetail" *ngFor="let doc of docList; let i = index;">
                <div class="col-3">
                    <label class="radioTitle d-flex">
                        <input type="radio" class="d-none" value="doc?.selected" [checked]="doc?.selected"
                            (click)="addDownloadFooter(doc?.file?.downloadUrl, i, doc)">
                        <div class="checkmark" (mouseenter)="hoverListItem(true, doc)"
                            (mouseleave)="hoverListItem(false, doc)">
                            <div class="greendot" *ngIf="doc?.selected && !doc?.hovered"></div>
                            <div class="graydot" *ngIf="!doc?.selected && doc?.hovered"></div>
                        </div>
                        <img class="docPreview ml-2" src="{{baseUrl}}{{doc?.image?.url}}">
                    </label>
                </div>
                <div class="col-9 d-flex">
                    <div class="pdfIcon">
                        <img class="pdfIcon" src="../../../assets/icons/{{baseSiteId}}/pdf.svg"
                            *ngIf="doc?.file?.mimeType == 'application/pdf'">
                    </div>
                    <div>
                        <h3 class="pdfTitle ml-2">{{doc?.header}}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-block">
            <div id="filter-applied">
                <div class="col filterApply-showing reimbursement-filter d-flex justify-content-center mt-3"
                    *ngIf="(currPage+1) < totalPages">
                    <span>Showing {{(docList.length) * (currPage+1)}} of {{totalDocuments}} documents</span>
                </div>
                <div class="col filterApply-showing reimbursement-filter d-flex justify-content-center mt-3"
                    *ngIf="(currPage+1) == totalPages">
                    <span>Showing {{totalDocuments}} of {{totalDocuments}} documents</span>
                </div>
                <div class="col d-flex justify-content-center">
                    <div class="pagination mt-4 mb-4">
                        <button class="pagination-btns mr-1" [disabled]="currPage == 0" (click)="paginationPrev()">
                            <span class="chevronIconWhite prev">
                                < </span>
                        </button>
                        <button class="pagination-btns" [disabled]="currPage == totalPages-1"
                            (click)="paginationNext()">
                            <span class="chevronIconWhite next"> > </span>
                        </button>
                    </div>
                </div>
                <div class="col top-pagination hidden-xs d-flex justify-content-center mb-3">
                    <div id="pageSelectedNumber">Page {{currPage + 1}} of {{totalPages}}</div>
                </div>
            </div>
        </div>

    </section>
    <section id="rightSection" class="col-md-4 col-lg-4 col-xl-4 qlinks authenticated-display">
        <h3 class="">Quick links</h3>
        <p>
            <a id="reimbursement-link"
                (click)="goToReimburseSupport(quickReimburseLinkCMS?.url)">{{quickReimburseLinkCMS?.linkName}}</a>
            <span>{{quickReimburseLinkCMS?.text}}</span>
        </p>
        <p>
            <a id="coding-link"
                (click)="openLinkInNewWindow(crackingTheCodeStrainingCMS?.url)">{{crackingTheCodeStrainingCMS?.linkName}}</a>
            <span>{{crackingTheCodeStrainingCMS?.text}}</span>
        </p>
    </section>
</section>